<template>
  <div class="statistics">
    <div v-for="(item, index) in list" :key="index" class="s-item space-item"  @click="toDetail(item)">
      <div v-if="item.type === 'total'" class="s-top total-top" style="cursor:pointer">
        <div class="num-box total">
          <span class="desc">总</span>
          <span class="num">{{ data[item.field] || item.num }}</span>
        </div>
        <div class="stub"></div>
        <div class="total-child">
          <div class="num-box">
            <span class="num">{{ data[item.field_done] || item.done }}</span>
            <span class="desc">已完成</span>
          </div>
          <div class="num-box">
            <span class="num">{{ data[item.field_unfinish] || item.unfinish }}</span>
            <span class="desc">未完成</span>
          </div>
        </div>
      </div>
      <div v-else class="s-top" style="cursor:pointer" @click="toDetail(item)">
        <div class="num-box">
          <span class="num">{{ data[item.field] || item.num }}</span>
          <span class="desc">个</span>
        </div>
      </div>
      <div class="s-tip">{{ item.tip }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statistics',
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    toDetail(item){
      var componentName = '';
      var uniqueId = item.tip;
      if(item.tip == '未完成服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '未完成现场服务单') {
        componentName = 'siteManage';
      } else if(item.tip == '未分配服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '本周总服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '已完成未对账服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '已完成未请款服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '总申请服务请求') {
        componentName = 'serviceRequest';
      } else if(item.tip == '近三天工程师忙闲情况') {
        componentName = 'siteManage';
        //以上是客服看板
      } else if(item.tip == '本月总服务请求'){
        componentName = 'serviceRequest';
      } else if(item.tip == '上周总服务请求'){
        componentName = 'serviceRequest';
      } else if(item.tip == '本月总现场服务单'){
        componentName = 'siteManage';
      } else if(item.tip == '本周总现场服务单'){
        componentName = 'siteManage';
      } else if(item.tip == '上周总现场服务单'){
        componentName = 'siteManage';
        //以上是管理看板
      } else if(item.tip == '完成服务请求'){
        componentName = 'serviceRequest';
      } else if(item.tip == '已到达现场服务单'){
        componentName = 'siteManage';
      } else if(item.tip == '异常服务请求'){
        componentName = 'serviceRequest';
      } else if(item.tip == '异常现场服务单'){
        componentName = 'siteManage';
      }
      this.baseComponent.smartLoadComponent(componentName, {title: item.tip, source: 'viewBoard', condition: '', requestUniqueId: item.tip}, {uniqueName: 'todo-' + uniqueId})
    }
  }
}
</script>

<style lang="postcss">
.statistics {
  display: flex;
  justify-content: space-between;
  width: 100%;

  & .s-item {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 10px 2px 10px;
    font-size: 14px;
    color: #4d4d4d;

    /* 有 space-item 实现 */
    /* &:not(:last-child) {
      margin-right: 10px;
    } */
  }
  & .s-top {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    margin-bottom: 10px;
  }
  & .s-tip {
    text-align: center;
    color: #0171f6;
  }

  & .num-box {
    display: flex;
    align-items: flex-end;

    & .num {
      font-size: 24px;
      color: #00a0e9;
    }
    & .desc {
      margin: 0 0 2px 3px;
    }
  }

  & .total-top {
    display: flex;
    align-items: center;

    & .stub {
      height: 100%;
      border-left: 1px solid #cccccc;
      margin: 0 7px;
    }

    & .total {
      & .num {
        margin-bottom: -6px;
        font-size: 30px;
      }
      & .desc {
        margin: 0 3px 0 0;
        font-size: 10px;
      }
    }

    & .total-child {
      & .num {
        margin-bottom: -2px;
        margin-right: 3px;
        /* font-size: 14px; */
        font-size: 16px;
      }
      & .desc {
        margin: 0;
        font-size: 10px;
      }
    }
  }
}
.s-item.space-item:hover {
  background-color: #f6fcff;
  /* background-color: rgba(221, 242, 255, 0.6); */
  -webkit-transform: translateY(-3px);
  transform: translateY(-3px)
}
.s-item.space-item,.s-item.space-item:hover {
  -webkit-transition: all .3s;
  transition: all .3s;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/statistics.vue